import { useSelector } from 'react-redux';
import './miniNav.css';

import BackBlackIcon from '@/assets/dashboard/navItems/backBlackIcon.png'
import BackWhiteIcon from '@/assets/dashboard/navItems/backWhiteIcon.png'

import { RootState } from '@/store';
import { addCurrentThemeClassToEle } from '@/utils';
import { themes } from '@/constants/colors_v2';
import { useSafeAreaInsets } from '@/hooks/useSafeAreaInsets';

export default function MobileMiniNav(props: any) {
    const { top: safeAreaTop } = useSafeAreaInsets();
    const capitalizeFirstLetter = (val: string) => {
        if (!val) return '';
        return val.charAt(0).toUpperCase() + val.slice(1);
    };

    const currentTheme = useSelector((state: RootState) => state.currentThemeReducer.currentTheme);

    return (
        <div
            style={{ zIndex: 20, paddingTop: safeAreaTop ? safeAreaTop+10+'px' : '' }}
            className={`miniNav mobileMiniNavMainX fixed top-[45px] min-[1280px]:top-0 left-0 right-0 flex items-center ${addCurrentThemeClassToEle(currentTheme, 'miniNav')}`}>
            <img
                onClick={() => props.redirectTo()}
                src={currentTheme === themes.light ? BackBlackIcon : BackWhiteIcon}
                alt='backBlackIcon' className='w-[10px] h-[16px] cursor-pointer' />
            <div className='flex justify-center w-[100%] navItem'>
                {capitalizeFirstLetter(props.navItemName)}
            </div>
        </div>
    );
}
